
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EditorState } from '@/types/editor';

@Component
export default class FacebookPreview extends Vue {
  @Prop() content!: EditorState;

  get imageExists(): boolean {
    return this.content.meta!.image !== null;
  }

  get imageUrl(): string {
    let imagePath = process.env.VUE_APP_DEFAULT_FEATURED_IMAGE;
    const fit =
      this.content.meta!.open_graph_image_crop === 'fit-in' ? 'fit-in/' : '';
    const smart =
      this.content.meta!.open_graph_image_crop === 'smart' ? 'smart/' : '';
    if (this.content.meta !== null) {
      if (this.imageExists) {
        imagePath = this.content.meta!.image!.path.replace(
          'https://cdn.alternativebusinessfunding.co.uk/',
          '',
        );
      }
    }
    return `https://cdn.alternativebusinessfunding.co.uk/${fit}526x274/${smart}${imagePath}`;
  }

  get title() {
    return this.content.meta!.open_graph_title !== null
      ? this.content.meta!.open_graph_title
      : this.content.meta!.meta_title !== null
        ? this.content.meta!.meta_title
        : this.content.meta!.title;
  }

  get description() {
    return this.content.meta!.open_graph_description !== null
      ? this.content.meta!.open_graph_description
      : this.content.meta!.meta_description !== null
        ? this.content.meta!.meta_description
        : this.content.summary;
  }
}
